export default {
  apiKey: "AIzaSyBr9nvGZB0H0ukQEpj7s14BMedgYjk8nso",
  authDomain: "who-is-going-to-daily-sync.firebaseapp.com",
  databaseURL: "https://who-is-going-to-daily-sync.firebaseio.com",
  projectId: "who-is-going-to-daily-sync",
  storageBucket: "who-is-going-to-daily-sync.appspot.com",
  messagingSenderId: "718831784479",
  appId: "1:718831784479:web:2c4cbf77eb9ad82fdafb2a",
  measurementId: "G-G5Y2ZQ9NS2",
};
